'use strict';

import './modules/polyfill-foreach.js';
import './modules/keyboard-mouse.js';
import './modules/navigation.js';
